import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { MessageDisplayBar } from 'ecs-react-components/dist/index.es';
import * as Actions from '../../redux/modules/system-shared/message-bar-action-creator';
import { messages } from './Message.i18n';
import * as MESSAGE_TYPES from '../../redux/modules/system-shared/message-types';

class Message extends React.Component {
  close = () => {
    this.props.dispatch(Actions.dismissMessage());
    if (this.props.onDismissed) {
      this.props.onDismissed();
    }
  }

  calculateAlertClass() {
    switch (this.props.messageType.toLowerCase()) {
      case MESSAGE_TYPES.MESSAGE_TYPE_NONE:
        return 'alert alert-none fade in alert-area';
      case MESSAGE_TYPES.MESSAGE_TYPE_SUCCESS:
        return 'alert alert-success fade in alert-area';
      case MESSAGE_TYPES.MESSAGE_TYPE_INFO:
        return 'alert alert-info fade in alert-area';
      case MESSAGE_TYPES.MESSAGE_TYPE_WARNING:
        return 'alert alert-warning fade in alert-area';
      case MESSAGE_TYPES.MESSAGE_TYPE_ERROR:
        return 'alert alert-danger fade in alert-area';
      default:
        return 'alert alert-danger fade in alert-area';
    }
  }

  calculateGlyphiconClass() {
    switch (this.props.messageType.toLowerCase()) {
      case MESSAGE_TYPES.MESSAGE_TYPE_SUCCESS:
        return 'glyphicon glyphicon-ok-sign';
      case MESSAGE_TYPES.MESSAGE_TYPE_INFO:
        return 'glyphicon glyphicon-info-sign';
      case MESSAGE_TYPES.MESSAGE_TYPE_WARNING:
        return 'glyphicon glyphicon-warning-sign';
      case MESSAGE_TYPES.MESSAGE_TYPE_ERROR:
        return 'glyphicon glyphicon-exclamation-sign';
      default:
        return 'glyphicon glyphicon-exclamation-sign';
    }
  }

  render() {
    if (typeof this.props.messageType === 'undefined'
        || this.props.messageType === MESSAGE_TYPES.MESSAGE_TYPE_NONE) {
      return null;
    }

    const { formatMessage } = this.props.intl;
    const messageToRender = !this.props.messageCode ? messages.unspecified : messages[this.props.messageCode];
    if (!messageToRender) {
      return null;
    }
    const parameter1 = (this.props.messageParameters && this.props.messageParameters[0]) ?
      this.props.messageParameters[0] : undefined;
    const parameter2 = (this.props.messageParameters && this.props.messageParameters[1]) ?
      this.props.messageParameters[1] : undefined;
    return (
        <MessageDisplayBar
          onClose={ this.close }
          message={<FormattedMessage id={messageToRender.id} defaultMessage={messageToRender.defaultMessage}
            values={{ parameter1, parameter2 }}
          />}
          alertClass={ this.calculateAlertClass() }
          glyphiconClass={ this.calculateGlyphiconClass() }
          dismissMessageSRLabel={ formatMessage(messages.dismissMessageLink) }
        />
    );
  }
}

Message.propTypes = {
  intl: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  messageType: PropTypes.string,
  messageCode: PropTypes.string,
  messageParameters: PropTypes.array,
  onDismissed: PropTypes.func,
};

const mapStateToProps = (state) => ({
  messageType: state.messageDisplayBar.messageType,
  messageCode: state.messageDisplayBar.messageCode,
  messageParameters: state.messageDisplayBar.messageParameters,
  messageLinkFunctions: state.messageDisplayBar.messageLinkFunctions,
});

export default connect(mapStateToProps)(injectIntl(Message));